import { ComponentStyleConfig } from '@chakra-ui/react';

export const DatePicker: ComponentStyleConfig = {
  baseStyle: {
    '.react-datepicker': {
      borderColor: 'M.30',
      borderRadius: 4,
      shadow: 'xl',
      background: 'M.20',
      p: 3,
      fontFamily: 'inherit',
    },
    '.react-datepicker-popper': {
      zIndex: 2,
    },
    '.react-datepicker__triangle': {
      display: 'none',
    },
    '.react-datepicker__navigation': {
      top: '16px',
      h: 4,
      w: 4,
    },
    '.react-datepicker__navigation:hover': {
      ' .react-datepicker__navigation-icon:before': {
        borderColor: 'M.70',
      },
    },
    '.react-datepicker__navigation--previous': {
      left: 'unset',
      right: '48px',
    },
    '.react-datepicker__navigation--next': {
      right: 3,
    },
    '.react-datepicker__navigation-icon': {
      transform: 'scale(0.6)',
      top: '2px',
      '&:before': {
        borderColor: 'iconBase',
        borderWidth: '2px 2px 0 0',
      },
    },
    '.react-datepicker__navigation-icon--next': {
      borderColor: 'M.70',
    },
    '.react-datepicker__navigation-icon--previous': {
      borderColor: 'M.60',
    },
    '.react-datepicker__month-container': {
      float: 'none',
    },
    '.react-datepicker__header': {
      background: 'none',
      border: 'none',
      padding: 0,
    },
    // Points to the day grid container.
    '.react-datepicker__month, .react-datepicker__year': {
      margin: 0,
    },
    '.react-datepicker__current-month, .react-datepicker-year-header': {
      cursor: 'pointer',
      color: 'M.70',
      width: 'fit-content',
      textAlign: 'left',
      fontSize: 'md',
      fontWeight: 500,
      lineHeight: 'normal',
      mb: 6,
    },
    '.react-datepicker__header__dropdown': {},
    '.react-datepicker__day-names': {
      mb: 2,
    },
    '.react-datepicker__day-name': {
      fontSize: 'sm',
      fontWeight: 400,
      lineHeight: '14.52px',
      letterSpacing: '0.96px',
      color: 'M.60',
      textAlign: 'center',
      w: 6,
      mx: 1.5,
      '&:first-of-type': {
        ml: 0,
      },
      '&:last-of-type': {
        mr: 0,
      },
    },
    '.react-datepicker__week': {
      my: 3,
      '&:last-of-type': {
        mb: 0,
      },
    },
    '.react-datepicker__day, .react-datepicker__year-text': {
      color: 'M.70',
      fontSize: 'sm',
      fontWeight: 400,
      lineHeight: 6,
      w: 6,
      textAlign: 'center',
      my: 0,
      mx: 1.5,
      '&:first-of-type': {
        ml: 0,
      },
      '&:last-of-type': {
        mr: 0,
      },
    },
    '.react-datepicker__day:hover, .react-datepicker__year-text:hover': {
      borderRadius: 4,
      bg: 'B.80',
      color: 'M.70',
    },
    '.react-datepicker__day--today': {
      color: 'B.80',
    },
    '.react-datepicker__day--selected, .react-datepicker__day--keyboard-selected, .react-datepicker__year-text--selected, .react-datepicker__year-text--keyboard-selected': {
      bg: 'B.80',
      color: 'M.70',
      borderRadius: 4,
      outline: 'none',
    },
    '.react-datepicker__day-weekend': {},
    '.react-datepicker__day--outside-month': {
      zIndex: -99999,
      opacity: 0,
      visibility: 'hidden',
      userEvents: 'none',
    },
    '.react-datepicker__year--container': {
      width: '266px',
      height: '309px',
    },
    '.react-datepicker__year-wrapper': {
      maxWidth: '266px',
    },
    '.react-datepicker__year-text': {
      flexBasis: '23%',
    },
  },
  variants: {},
  sizes: {},
  defaultProps: {},
};
